<script>
    export let width = "78vw";
    export let font_size = "4.206vw";
    export let coming_data = [];
    $: console.log("coming_data", coming_data);
</script>

<div class="desktop">
    <div class="gallery" style="width:{width};">
        {#each coming_data as data}
            <div class="gallery_tab">
                <img src={data.src} alt="" width="100%" />
                <div class="title">
                    <h1>{@html data.title}</h1>
                </div>
            </div>
        {/each}
    </div>
</div>

<div class="mobile">
    <div class="gallery" style="width:{width};">
        {#each coming_data as data}
            <div class="gallery_tab">
                <img src={data.src} alt="" width="100%" />
                <div class="title" style="bottom: {data.bottom_value};">
                    <h2 style="font-size:{font_size} ;">{@html data.title}</h2>
                </div>
            </div>
        {/each}
    </div>
</div>

<style>
    .gallery {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        margin: auto;
    }
    .gallery_tab {
        width: 15.729vw;
        height: 10.521vw;
        border-radius: 1.042vw;
        overflow: hidden;
        margin-bottom: 2vw;
        position: relative;
    }
    h1 {
        font-size: 1.146vw;
        font-weight: 800;
        color: white;
        
    }

    h2{

        font-size: 3vw;
        font-weight: 800;
        color: white;
        line-height: 5vw;
    }
    .title {
        position: absolute;
        bottom: 0.7vw;
        left: 1vw;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
        .gallery {
            justify-content: space-between;
        }
        .gallery_tab {
            width: 37.85vw;
            height: 36.916vw;
            border-radius: 4.673vw;
            margin-bottom: 5.14vw;
        }
        .gallery_tab img {
            width: 100%;
            height: 100%;
        }
        .title {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 38.3vw;
            height: 17.523vw;
            text-align: center;
        }
        .title h1 {
            font-size: 4.206vw;
        }
    }
</style>
